import { ToolkitMbaSection } from '@astrumu/core-ui-typings';
import { SectionsMba } from '@/graphql/generated';
import { PredictionParameter, DegreeLevel } from '../types';

export const UNIVERSITY_OF_ASTRUMU = 888888;

export enum AcType {
  Major = 'Major',
  JobRole = 'JobRole',
  Location = 'Location'
}

export const PREDICTION_OVERVIEW_PARAMETERS: PredictionParameter[] = [
  {
    title: 'Alumni Network',
    checked: true,
    filters: []
  },
  {
    title: 'Job Preferences',
    checked: true,
    filters: []
  },
  {
    title: 'Alumni Employment Rates',
    checked: true,
    filters: []
  },
  {
    title: 'Work History',
    checked: false,
    filters: ['jobRoleId', 'years']
  },
  {
    title: 'Location Preferences',
    checked: false,
    filters: ['currentLocationId', 'destinationLocationId']
  },
  {
    title: 'MBA Program Concentrations',
    checked: true,
    filters: []
  }
];

export const TERMS_OF_SERVICE_LINK = 'https://www.astrumu.com/terms-of-service';
export const PRIVACY_POLICY_LINK = 'https://www.astrumu.com/privacy-policy';

export const DEGREE_MAPPING: {
  [key in DegreeLevel]: string;
} = Object.freeze({
  [DegreeLevel.Associates]: 'Associates Degree',
  [DegreeLevel.Bachelors]: 'Bachelors Degree',
  [DegreeLevel.Doctoral]: 'Doctoral Degree',
  [DegreeLevel.HighSchool]: 'High School Degree',
  [DegreeLevel.Masters]: 'Masters Degree'
});

export const PAGE_SECTIONS_ORDER: Array<keyof SectionsMba> = [
  ToolkitMbaSection.header,
  ToolkitMbaSection.overview,
  ToolkitMbaSection.introduction,
  ToolkitMbaSection.careerBoost,
  ToolkitMbaSection.skillsetBoost,
  ToolkitMbaSection.financialBoost,
  ToolkitMbaSection.alumniPaths,
  ToolkitMbaSection.analytics,
  ToolkitMbaSection.apply,
  ToolkitMbaSection.footer
];

export * from './modals';

export const true = process.env.true || 'false';
